import React, { useEffect, useState } from "react";
import SaveChangesButton from "./SaveChangesButton";

const LoginPass = ({
  helpData,
  setHelpData,
  originalHelpData,
  handleHelpSubmit
}) => {
  const [hasChanges, setHasChanges] = useState(false);

  // Set default values if helpData is null/undefined
  const safeHelpData = helpData || { email_id: "", pass_id: "" };

  useEffect(() => {
    if (!originalHelpData) return;
    const changed = JSON.stringify(safeHelpData) !== JSON.stringify(originalHelpData);
    setHasChanges(changed);
  }, [safeHelpData, originalHelpData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHelpData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="profile-form-container">
      {/* Support Phone Number */}
      <div className="profile-form-group">
        <label className="profile-form-label">Email ID</label>
        <input
          type="text"
          name="email_id"
          value={safeHelpData.email_id}
          onChange={handleChange}
          className="profile-form-input"
          placeholder="Enter Email"
        />
      </div>

      {/* Support WhatsApp Number */}
      <div className="profile-form-group">
        <label className="profile-form-label">Passkey</label>
        <input
          type="text"
          name="pass_id"
          value={safeHelpData.pass_id}
          onChange={handleChange}
          className="profile-form-input"
          placeholder="Enter Passkey"
        />
      </div>

      {/* Save Button */}
      
        <div className="profile-form-group full-span">
          <SaveChangesButton onClick={handleHelpSubmit} />
        </div>
    
    </div>
  );
};

export default LoginPass;
